import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import { HiBadgeCheck } from "react-icons/hi";
import { BsBookmarkStarFill, BsStarFill } from "react-icons/bs";
import Rating from "../Rating";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { successToaster } from "../../utils/index";
import { getLocalStorage } from "./../../utils/helper";
import apiClient from "../../utils/api";
import "./styles.css";
import { AddressForm } from "../Forms/addressForm";

export default function Product(props) {
  const isLogin = getLocalStorage("uid") ? true : false;
  let nav = useNavigate();
  const [count, setCount] = useState(1);
  const [ratings, setRatings] = useState(0);
  const [allRating, setAllRating] = useState();
  const [data, setData] = useState({});
  const param = useParams();
  const [userData, setUserData] = useState(false);
  const [addressData, setAddressData] = useState([]);
   const { productId } = useParams();
   const [showAddressForm, setShowAddressForm] = useState(false);

  const handleIncrement = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const handleDecrement = () => {
    if (count !== 1) setCount((prevCount) => prevCount - 1);
  };

  const toggleState = (clickState) => {
    setRatings(clickState);
  };

  const fetchData = () => {
    apiClient
      .post(`get/product.php`, {
        product_id: param.productId,
      })
      .then((res) => {
        console.log("📌 Product API Response:", res.data);

        let info = {};
        if (Array.isArray(res.data) && res.data.length > 0) {
          info = res.data[0];
        } else if (res.data && typeof res.data === "object") {
          info = res.data;
        }
        setData(info);
        setCount(1);
      })
      .catch((err) => {
        console.log("❌ fetchData error:", err);
      });
  };

  const postData = async (e) => {
    if (e?.preventDefault) e.preventDefault();
  if (!isLogin) {
    nav(`/profile/${param.productId}`);
    return;
 }
  if (!userData?.email) {
    // optional: toaster/alert
   return;
 }
      let info = {
        product_id: param.productId,
        user_id: userData.email,
        quantity: count,
      };

      apiClient
        .post(`post/cart.php`, { ...info })
        .then(() => {
          successToaster({ msg: "Added to cart" });
          setCount(1);
        })
        .catch((err) => {
          console.log(err);
        });
  };

  // const buyPostData = async (e) => {
  //   if (isLogin === false) {
  //     nav("/profile/:productId");
  //   } else {
  //     e.preventDefault();
  //     let info = {
  //       product_id: param.productId,
  //       user_id: userData.email,
  //       quantity: count,
  //     };

  //     apiClient
  //       .post(`post/cart.php`, { ...info })
  //       .then(() => {
  //         nav("/cart/:productId");
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // };
  const buyPostData = async (e) => {
  if (e?.preventDefault) e.preventDefault();

  if (!isLogin) {
    nav(`/profile/${param.productId}`);
    return;
  }
 if (!userData?.email) {
  // optional: toaster/alert   
  return;
  }

  const info = {
    product_id: param.productId,
    user_id: userData.email,
    quantity: count,
  };

  try {
    await apiClient.post(`post/cart.php`, info);
    const res = await apiClient.post("get/user.php", { user_id: userData.email });
    const userDetails = Array.isArray(res.data) ? res.data[0] : res.data;

    const hasAddress =
      userDetails &&
      userDetails.address &&
      userDetails.address !== "0" &&
      userDetails.address.trim() !== "" &&
      userDetails.address.toLowerCase() !== "n/a";

    if (hasAddress) {
      nav(`/cart/${param.productId}`);
    } else {
      setShowAddressForm(true);
    }
  } catch (err) {
    console.log("❌ buyPostData error:", err);
  }
};


  // const swapFocusImg = (key) => {
  //   let info = { ...data };
  //   info[key] = info.img1;
  //   info.img1 = data[key];
  //   setData(info);
  // };

  // ✅ Swap main and clicked image
  const swapFocusImg = (key) => {
    setData((prevData) => {
      let updatedData = { ...prevData };

      // swap main image with clicked sub image
      const temp = updatedData.img1;
      updatedData.img1 = updatedData[key];
      updatedData[key] = temp;

      return updatedData;
    });
  };

  const overallRating = async () => {
    await apiClient
      .post(`get/ratings.php`, {
        product_id: param.productId,
      })
      .then((res) => {
        setAllRating(res.data);
      });
  };

  const addressFetchData = async () => {
      if (!userData?.email) return;
      try {
        const res = await apiClient.post(`get/user.php`, {
          user_id: userData.email,
        });
        setAddressData(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.log("addressFetchData err:", err);
        setAddressData([]);
      }
    };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
            @media (max-width: 998px) {
              .custom-mobile-margin {
                margin-top: 10% !important;
              }
            }
            @media (max-width: 750px) {
              .custom-mobile-margin {
                margin-top: 15% !important;
              }
            }
            @media (max-width: 500px) {
              .custom-mobile-margin {
                margin-top: 19% !important;
              }
            }
          `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const submitRating = async (rate) => {
    apiClient
      .post(`post/ratings.php`, {
        user_id: userData.email,
        product_id: param.productId,
        rating: rate,
      })
      .then(() => {
        successToaster({ msg: "Rating added successfully" });
        overallRating();
      });
  };

  useEffect(() => {
    setTimeout(() => {
      setUserData(userInfo());
      fetchData();
      overallRating();
      window.scrollTo(0, 0);
    }, 200);
  }, [param.productId]);

  return (
    <>
      <section className="productPage" key={data.product_id}>
        <div className="container pb-5 product">
          <div className="row">
            {/* Left Side Product Images */}
            <div className="col-lg-5 mt-5 custom-mobile-margin">
              <div className="card mb-3">
                <img
                  className="card-img img-fluid productDetailImg"
                  src={data.img1}
                  alt="Sri Mangalambika Stores products"
                  id="product-detail"
                />
              </div>
              <div className="row">
                <div className="col-1 align-self-center"></div>
                <div
                  id="multi-item-example"
                  className="col-10 carousel slide carousel-multi-item"
                  data-bs-ride="carousel"
                >
                  <div
                    className="carousel-inner product-links-wap"
                    role="listbox"
                  >
                    <div className="carousel-item active">
                      <div className="row">
                        {["img2", "img3", "img4"].map((imgKey, i) => (
                          <div
                            key={i}
                            className="col-4"
                            onClick={() => swapFocusImg(imgKey)}
                          >
                            <img
                              className="card-img img-fluid productDetailSubImg"
                              src={data[imgKey]}
                              alt="Sri Mangalambika Stores products"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-1 align-self-center"></div>
              </div>
            </div>

            {/* Right Side Product Details */}
            <div className="col-lg-7 mt-5">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start">
                    <h1 className="h5 text-uppercase productDetailTitle">
                      {data.product_name}{" "}
                      {/* <small style={{ fontSize: "15px" }}>
                        ({data.weight} Gms.)
                      </small> */}
                    </h1>
                    {/* <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#infoModal"
                      style={{
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        padding: "0",
                      }}
                      title="More Info"
                    >
                      i
                    </button> */}
                  </div>

                  {/* Price Section */}
                  <p>
                    <span
                      className="list-inline-item text-dark fw-700"
                      style={{ fontSize: "1.4em" }}
                    >
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {data.offer_price}
                    </span>
                    <span
                      className="list-inline-item text-secondary"
                      style={{
                        fontSize: "1em",
                        textDecoration: "line-through",
                      }}
                    >
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {data.price}
                    </span>
                    <span
                      className="list-inline-item"
                      style={{ fontSize: "1em", color: "green" }}
                    >
                      {data.offer}%{" "}
                      <small style={{ fontSize: ".7em" }}>Discount</small>
                    </span>
                  </p>

                  {/* Quantity & Buttons */}
                  <div role="form">
                    <div className="col-auto">
                      <ul className="list-inline pb-3">
                        <li className="list-inline-item text-right">
                          Quantity
                        </li>
                        <li className="list-inline-item">
                          <span
                            className="btn btn-sm btn-success"
                            onClick={handleDecrement}
                          >
                            -
                          </span>
                        </li>
                        <li className="list-inline-item">
                          <span className="badge bg-light text-dark">
                            {count}
                          </span>
                        </li>
                        <li className="list-inline-item">
                          <span
                            className="btn btn-sm btn-success"
                            onClick={handleIncrement}
                          >
                            +
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="row pb-3">
                      <div className="col d-grid">
                        <button
                          onClick={buyPostData}
                          type="button"
                          className="btn btn-success btn-sm py-2 text-uppercase"
                          disabled={data.status === 0}
                        >
                          Buy Now
                        </button>
                      </div>
                      <div className="col d-grid">
                        <button
                          onClick={postData}
                          type="button"
                          className="btn btn-warning btn-sm py-2 text-uppercase"
                          disabled={data.status === 0}
                        >
                          Add To Cart
                        </button>
                      </div>
                    </div>
                    {/* 🚀 AddressForm in Popup */}
                  </div>
                  {showAddressForm && (
                    <div
                      className="modal fade show d-block"
                      tabIndex="-1"
                      role="dialog"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              Enter Delivery Address
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowAddressForm(false)}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <AddressForm
                              hide={() => setShowAddressForm(false)}
                              addressData={() => addressFetchData()} // ✅ now it's a function
                              onSubmit={async (address) => {
                                try {
                                  await apiClient.post("put/user.php", {
                                    user_id: userData.email,
                                    ...address,
                                  });
                                  await addressFetchData(); // refresh after saving
                                  setShowAddressForm(false);
                                  nav(`/cart/${param.productId}`);
                                } catch (err) {
                                  console.log("Error saving address:", err);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Description */}
                  <h6
                    className="text-uppercase mt-3"
                    style={{ color: "#757575" }}
                  >
                    Description:
                  </h6>

                  <div
                    style={{
                      fontSize: "15px",
                      textAlign: "justify",
                      lineHeight: "1.7em",
                      fontWeight: "350",
                      fontFamily: "poppins",
                        whiteSpace: "pre-line",
                    }}
                    title={data?.description}
                  >
                    {data?.description
                      ?.split(".")
                      .filter((line) => line.trim() !== "")
                      .map((line, index) => (
                        <p key={index} style={{ marginBottom: "6px" }}>
                          {line.trim()}
                        </p>
                      ))}
                  </div>

                  {/* Ingredients */}
                  {/* <h6
                    className="text-uppercase mt-3"
                    style={{ color: "#000", fontSize: "15px" }}
                  >
                    <HiBadgeCheck
                      style={{
                        marginTop: "-4px",
                        color: "green",
                        fontSize: "20px",
                      }}
                      className="me-1"
                    />
                    Ingredients:
                  </h6>
                  <ul className="text-capitalize pb-2 ingrediants">
                    <li>{data.ingredients}</li>
                  </ul> */}

                  {/* Instructions */}
                  {/* <h6
                    className="text-uppercase mt-3"
                    style={{ color: "#000", fontSize: "15px" }}
                  >
                    <HiBadgeCheck
                      style={{
                        marginTop: "-4px",
                        color: "green",
                        fontSize: "20px",
                      }}
                      className="me-1"
                    />
                    Methods of Application:
                  </h6> */}
                  {/* <p
                    style={{
                      fontSize: "15px",
                      textAlign: "justify",
                      lineHeight: "1.7em",
                      fontWeight: "350",
                    }}
                  >
                    {data.instructions}
                  </p> */}
                </div>
              </div>

              {/* Ratings */}
              <div className="card mt-2">
                <div className="card-body">
                  <div className="d-flex align-items-center position-relative ratingDiv">
                    <h1
                      className="h5 text-capitalize"
                      style={{ color: "#000", fontSize: "20px" }}
                    >
                      Ratings
                    </h1>
                    <button
                      className="position-absolute end-0"
                      onClick={() => toggleState(1)}
                    >
                      Rate Product
                    </button>
                  </div>
                  <h6
                    className="text-uppercase mt-3 mb-3"
                    style={{ color: "#000", fontSize: "15px" }}
                  >
                    <BsBookmarkStarFill
                      style={{
                        marginTop: "-4px",
                        color: "#f39c12",
                        fontSize: "20px",
                      }}
                      className="me-1"
                    />
                    Overall Ratings
                  </h6>
                  <div className="d-flex align-items-center">
                    <span style={{ fontSize: "1.5em" }}>{allRating}</span>
                    &nbsp;
                    <BsStarFill />
                  </div>
                </div>
                {ratings === 1 && (
                  <div className="card-body">
                    <h5>Enter Your Ratings</h5>
                    <Rating
                      rating={ratings}
                      onRating={(rate) => setRatings(rate)}
                      submitRating={submitRating}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
  